import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6748d4ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-image" }
const _hoisted_3 = { class: "image" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center_spinner" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "custom-card-content" }
const _hoisted_10 = { class: "media" }
const _hoisted_11 = { class: "media-left" }
const _hoisted_12 = { class: "title is-5" }
const _hoisted_13 = { class: "subtitle is-6" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Leer más > ")

import { onMounted, ref } from "vue";
import News from "@/entities/news";
import { useImage } from "@vueuse/core";
import logoAntai from "@/assets/logo_antai_news.jpg"

interface Props {
  currentNew: News;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    currentNew: null
  },
  setup(__props: any) {

const props = __props as {
  currentNew: News;
}


const useDefaultImage = ref<boolean>(false);

const { isLoading } = useImage({
  src: props.currentNew.news_thumbnail_image?.image.url
    ? props.currentNew.news_thumbnail_image?.image.url : ''});

onMounted(() => {
  if (props.currentNew.news_thumbnail_image == undefined) {
    useDefaultImage.value = !useDefaultImage.value;
  }
});

const convertDate = (date: string) => {
  const formatedDate = new Date(date).toLocaleDateString("es-ES", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const aux = formatedDate.toString();
  return aux[0].toUpperCase() + aux.substring(1);
};

const truncateText = (text: string, maxCharactersInText = 75) => {
  return text.length >= maxCharactersInText
    ? text.substr(0, maxCharactersInText - 1) + "..."
    : text;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("figure", _hoisted_3, [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                src: useDefaultImage.value ? _unref(logoAntai) : __props.currentNew.news_thumbnail_image.image.url,
                alt: "Placeholder image"
              }, null, 8, _hoisted_8)
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", _hoisted_12, _toDisplayString(truncateText(props.currentNew.title, 30)), 1),
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("small", null, _toDisplayString(convertDate(props.currentNew.created_at)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode(_toDisplayString(truncateText(__props.currentNew.text_intro)) + " ", 1),
        _hoisted_15,
        _createVNode(_component_router_link, {
          title: `Leer más acerca de ${__props.currentNew.title}`,
          to: {
            name: 'public-news-show',
            params: { newsId: __props.currentNew.id },
          }
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["title", "to"])
      ])
    ])
  ]))
}
}

})